import { Blogs } from "../../../../../components/backgrounds/Blogs";

export function AppsPage() {
  return (
    <>
      <Blogs
        title={"4 apps para llevar un registro financiero"}
        content={
          <>
            <div className="pt-6 opacity-60 text-xl">
              <p className="">
                Hola astronauta, ¿Sigues controlando tus finanzas con papel y
                lápiz? ¿Quieres pasarte a un método más organizado? ¿Te gustaría
                digitalizar tus finanzas personales? En este blog te contamos
                qué apps puedes usar para que lleves las riendas de tu vida
                financiera.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Seriamente cuando recibes tu pago mensual o quincenal tienes en
                cuenta tus responsabilidades financieras, pagas tus deudas, tus
                compromisos y lo que queda lo dejas para satisfacer esos gustos
                que quieras darte. Si lo que quieres es manejar tus finanzas
                como un ‘pro’ debes dejar de hacer esto y comenzar a llevar un
                registro de tus finanzas, de tus ingresos, tus compromisos, tus
                ahorros y tu dinero libre.
              </p>
            </div>
            <div className="pt-10 pb-10 opacity-60 text-xl">
              <p className="">
                Sabemos que muchas veces olvidamos llevar un registro, o lo
                hacemos en papel y lo perdemos, o simplemente no sabemos cómo
                hacerlo. Aquí te recomendamos 4 aplicaciones ideales para llevar
                un registro financiero, encuentra la que mejor se adapte a ti y
                descárgala.
              </p>
            </div>
            <span className="text-xl lg:text-2xl font-light">
              <a href="/registrarse" className="text-purple hover:underline">
                Si necesitas un crédito rápido de hasta $1.000.000 solicítalo
                ahora haciendo clic acá
              </a>
            </span>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">
                Mobills - Finanzas Personales:
              </span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Mobills es una aplicación de control financiero personal que te
                permite registrar y administrar tus cuentas de forma eficiente.
                Utiliza Mobills y conoce hacia dónde va tu dinero.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Funciones:</p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <ul role="list" className="pl-6 list-disc">
                <li>Gestor de tarjetas de crédito</li>
                <li>Planificación con metas y presupuestos</li>
                <li>Extracto mensual por categorías</li>
                <li>Gráficos e informes personalizados</li>
                <li>Filtros avanzados por cuentas, categorías y etiquetas</li>
                <li>
                  Sincronización en la nube (Puedes utilizarla en línea y sin
                  conexión)
                </li>
                <li>Gestor de objetivos financieros</li>
                <li>Almacenamiento de cupones fiscales</li>
                <li>
                  Alertas de cuentas a pagar (Notificación y correo electrónico)
                </li>
                <li>Gráficos de flujo de caja mensual y anual</li>
                <li>Soporte vía chat por la propia aplicación</li>
                <li>Control de deudas</li>
              </ul>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Disponible para Android, IOS, Windows Phone.</p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">Money Manager:</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Es una aplicación optimizada para la gestión de cuentas
                personales. La configuración predeterminada te ayudará a
                comenzar, y una vez que te acostumbres, podrás modificar la
                configuración según tus necesidades con las funciones altamente
                flexibles y personalizables disponibles.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Funciones:</p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <ul role="list" className="pl-6 list-disc">
                <li>Facilita la gestión eficiente de la cuenta</li>
                <li>Función de administrador de PC</li>
                <li>Función de gestión de presupuesto</li>
                <li>Función de gestión de tarjeta de crédito/débito</li>
                <li>
                  Transferencia automática de dinero y funciones de frecuencia
                </li>
                <li>Ordenar gastos por destinatario</li>
                <li>
                  Puedes ingresar fácilmente gastos frecuentes creando perfiles
                  de pago
                </li>
                <li>Copia de seguridad de restauración</li>
                <li>Compatibilidad con varias monedas</li>
              </ul>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Disponible para Android, IOS.</p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">Moneyboard:</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                Esta app te permite ingresar todas las transacciones que
                realices diariamente. Cuenta con un sistema que filtra por
                meses, semanas e incluso por años, cada uno de tus movimientos
                financieros.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Funciones:</p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <ul role="list" className="pl-6 list-disc">
                <li>Rápido y fácil de agregar gastos o ingresos</li>
                <li>
                  Sincronización de iCloud en todos sus dispositivos Apple
                </li>
                <li>Establecer y monitorear presupuestos</li>
                <li>
                  Personaliza tu experiencia con categorías de gastos
                  personalizadas, colores y más
                </li>
                <li>Mantener múltiples cuentas, en diferentes monedas</li>
                <li>Entradas de gastos o ingresos recurrentes</li>
                <li>
                  Visualiza tus transacciones con nuestros poderosos gráficos
                </li>
                <li>Privado y seguro con Face ID o Touch ID</li>
              </ul>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Disponible en iPhone, iPad y Mac.</p>
            </div>
            <div className="pt-10">
              <span className="text-2xl lg:text-4xl">1Money:</span>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">
                La aplicación te mostrará a dónde está yendo tu dinero. Mantener
                un seguimiento de tus finanzas frecuentemente no es lo más
                agradable del mundo, y requiere conocimientos y habilidades
                específicas. Por eso esta app ha desarrollado un programa que te
                hará fácil rastrear tus gastos en un toque.
              </p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <p className="">Funciones:</p>
            </div>
            <div className="pt-10 opacity-60 text-xl">
              <ul role="list" className="pl-6 list-disc">
                <li>Agrega una nueva transacción con un solo toque</li>
                <li>
                  Registra cada gasto a lo largo del día, y la aplicación te
                  mostrará en qué gastas tu dinero, en una tabla informativa
                </li>
                <li>
                  Puedes planear tus ingresos y gastos, lo cual te ayudará a
                  evitar compras no deseadas
                </li>
                <li>
                  Sigue de cerca los saldos de tus cuentas y alcanza
                  eficientemente tus metas financieras
                </li>
                <li>
                  Sigue tus finanzas en todos los dispositivos simultáneamente
                  mediante sincronización de datos en la nube
                </li>
              </ul>
            </div>
          </>
        }
        enlace1={
          <a
            href="/blog/como-mejorar-mi-puntaje-en-datacredito"
            className="text-purple hover:underline"
          >
            ¿Cómo mejorar mi puntaje de crédito?
          </a>
        }
        enlace2={
          <a href="/blog/6-consejos-para-manejar-tus-finanzas" className="text-purple hover:underline">
            6 consejos para manejar tus finanzas
          </a>
        }
        enlace3={
          <a href="/blog/como-construir-historial-crediticio" className="text-purple hover:underline">
            Cómo construir historial crediticio
          </a>
        }
      />
    </>
  );
}
